import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupsIcon from "@mui/icons-material/Groups";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import HistoryIcon from "@mui/icons-material/History";
import SettingsIcon from "@mui/icons-material/Settings";
import StarIcon from "@mui/icons-material/Star";
import PersonIcon from "@mui/icons-material/Person";
import type { SvgIconComponent } from "@mui/icons-material";

export const DRAWER_WIDTH = 256;

export enum NavSection {
  Main = "main",
  Management = "management",
}

export interface NavItem {
  label: string;
  i18nKey: string;
  path: string;
  icon: SvgIconComponent;
  requiresAuth: boolean;
  section: NavSection;
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: "Dashboard",
    i18nKey: "nav.dashboard",
    path: "/",
    icon: DashboardIcon,
    requiresAuth: false,
    section: NavSection.Main,
  },
  {
    label: "Players",
    i18nKey: "nav.players",
    path: "/players",
    icon: PeopleIcon,
    requiresAuth: true,
    section: NavSection.Main,
  },
  {
    label: "Teams",
    i18nKey: "nav.teams",
    path: "/teams",
    icon: GroupsIcon,
    requiresAuth: true,
    section: NavSection.Main,
  },
  {
    label: "Statistics",
    i18nKey: "nav.statistics",
    path: "/statistics",
    icon: BarChartIcon,
    requiresAuth: true,
    section: NavSection.Main,
  },
  {
    label: "History",
    i18nKey: "nav.history",
    path: "/history",
    icon: HistoryIcon,
    requiresAuth: true,
    section: NavSection.Management,
  },
  {
    label: "Bonus Points",
    i18nKey: "nav.bonusPoints",
    path: "/bonus",
    icon: StarIcon,
    requiresAuth: true,
    section: NavSection.Management,
  },
  {
    label: "Settings",
    i18nKey: "nav.settings",
    path: "/settings",
    icon: SettingsIcon,
    requiresAuth: true,
    section: NavSection.Management,
  },
  {
    label: "Account",
    i18nKey: "nav.account",
    path: "/account",
    icon: PersonIcon,
    requiresAuth: false,
    section: NavSection.Management,
  },
];
